import Cookies from "js-cookie"

export const StorageCookies = ({ access_token, refresh_token, user }) => {

    if (user) {
        Cookies.set('user', JSON.stringify(user), { expires: 5 })
    }
    if (access_token) {
        Cookies.set('access_token', JSON.stringify(access_token), { expires: 5 })
    }
    if (refresh_token) {
        console.log("🚀 ~ refresh_token:", refresh_token)
        Cookies.set('refresh_token', JSON.stringify(refresh_token), { expires: 5 })
    }
}